export const faq_application = [
  {
    title:
      "I run a not-for-profit organization. Can I apply for the Buddha Fellowship?",

    content:
      "We support early-stage, for-profit enterprises that create a direct impact on ground-level communities. Purely not-for-profit organizations are not eligible at present. However, if you run a hybrid organization with both for-profit and not-for-profit components, you can apply.",
  },
  {
    title:
      "I registered my organization last year. Can I apply for the Buddha Fellowship?",

    content:
      "Enterprises must be registered and operational for at least two years to be eligible to apply for the Buddha Fellowship. If you registered your enterprise last year, you'll be eligible to apply next year once you complete two years of operations.",
  },
  {
    title: "I am unable to fill in the application form. How can I apply?",

    content: `If owing to technical or language issues you are unable to submit your application, you can get in touch with us at <a href="mailto:admissions@thebuddhainstitute.org" class="text-[#22574D] underline">admissions@thebuddhainstitute.org</a>. Our team will support you in filling out the application.`,
  },
  {
    title:
      "I have submitted my application for the Buddha Fellowship Program but I have not heard back anything. What do I do?",

    content: `Due to the high volume of applications we receive, we are unable to respond and update applicants individually regarding their application status. However, you are always welcome to write to us at <a href= "mailto:admissions@thebuddhainstitute.org" class="text-[#22574D] underline">admissions@thebuddhainstitute.org</a> to request a status update on your application.`,
  },
  {
    title:
      "I do not have some/all the documents required in the application form. How can I apply?",

    content: `All documents requested in the application form are mandatory to submit. If due to any unforeseen circumstances you do not have one or more documents, you can write to us at <a href="mailto:admissions@thebuddhainstitute.org" class="text-[#22574D] underline">admissions@thebuddhainstitute.org</a> with details of your case.`,
  },
  {
    title:
      "I have received an interview call but I am not available at that time. What shall I do?",

    content:
      "We understand that Development Entrepreneurs are often in the field and in remote areas with limited access to phone networks at times. If you have received an email for an interview at a time when you are not available, you can respond to that email with your preferred times and we will work to get your interview time changed.",
  },
  {
    title:
      "I have a recommendation for a potential Buddha Fellow. Who can I share it with?",

    content: `Thanks! We are always looking for recommendations for good entrepreneurs driven to make a difference at the grassroots level. If you know one such entrepreneur, please feel free to share their details with us at <a href="mailto:admissions@thebuddhainstitute.org" class="text-[#22574D] underline">admissions@thebuddhainstitute.org</a>`,
  },
  {
    title: "Can I connect with or speak to a current or past Buddha Fellow?",

    content:
      "Yes, absolutely. We encourage applicants to connect with existing Buddha Fellows to build a more comprehensive understanding of the program. The LinkedIn profile of all Buddha Fellows are listed under the section titled ‘Buddha Fellows’ on our website. Feel free to contact any of them.",
  },
];
export const data = {
  synergyFirstArray: [
    {
      image: "/BudhaFellowProgram/synergy-img-1.jpg",
      id: "1",
    },
    {
      image: "/BudhaFellowProgram/synergy-img-2.jpg",
      id: "2",
    },
    {
      image: "/BudhaFellowProgram/synergy-img-3.jpg",
      id: "3",
    },
    {
      image: "/BudhaFellowProgram/synergy-img-4.jpg",
      id: "4",
    },
    {
      image: "/BudhaFellowProgram/synergy-img-5.jpg",
      id: "5",
    },
  ],
  synergySecondArray: [
    {
      image: "/BudhaFellowProgram/synergy-img-6.jpg",
      id: "1",
    },
    {
      image: "/BudhaFellowProgram/synergy-img-7.jpg",
      id: "2",
    },
    {
      image: "/BudhaFellowProgram/synergy-img-8.jpg",
      id: "3",
    },
    {
      image: "/BudhaFellowProgram/synergy-img-9.jpg",
      id: "4",
    },
    {
      image: "/BudhaFellowProgram/synergy-img-10.jpg",
      id: "5  ",
    },
  ],
};
